import {
  Card,
  CardContent,
  CardMedia,
  Box,
  Typography,
  useTheme,
} from "@mui/material"
import { deepmerge } from "@mui/utils"

export const BenchasiriEventCard = ({
  title,
  subtitle,
  imageSrc,
  sx = {},
  ...props
}) => {
  const theme = useTheme()
  const styleOverrides =
    theme.components[`EmBenchasiriEventCard`]?.styleOverrides || {}

  const { root, content, media, textContainer, titleText, subtitleText } =
    styleOverrides

  return (
    <Card sx={deepmerge(root, sx)} {...props}>
      <CardContent sx={content}>
        <CardMedia component="img" src={imageSrc} sx={media} />
        <Box sx={textContainer}>
          <Typography variant="title" sx={titleText}>
            {title}
          </Typography>
          <Typography color="text.secondary" sx={subtitleText}>
            {subtitle}
          </Typography>
        </Box>
      </CardContent>
    </Card>
  )
}
